import { NoSsr } from "@mui/base";
import type { FunctionComponent } from "react";

import { headerEditionOptions, useEdition, useEditionValue } from "shared/lib/edition";

import { EpaperLink } from "scmp-app/components/epaper-link";
import { useHeaderFeaturesProvider } from "scmp-app/components/header/features/hooks";
import { SCMPPlusLink } from "scmp-app/components/scmp-plus-link";

import {
  CenterWrapper,
  Container,
  Edition,
  EditionList,
  LeftWrapper,
  RightWrapper,
  Wrapper,
} from "./styles";

export type Props = {
  className?: string;
};

export const HomeEdition: FunctionComponent<Props> = ({ className }) => {
  const edition = useEditionValue();
  const { update: updateEdition } = useEdition();

  const headerFeatureProvider = useHeaderFeaturesProvider();

  return (
    <Container aria-label="Primary" className={className}>
      <Wrapper>
        <LeftWrapper>
          {headerFeatureProvider.hamburgerMenu({ showIn: "mobileAndTablet" })}
          {headerFeatureProvider.search({ showIn: "mobileAndTablet" })}
          {headerFeatureProvider.searchBar({ showIn: "desktopUp" })}
        </LeftWrapper>
        <CenterWrapper>
          <EditionList>
            <NoSsr>
              {headerEditionOptions.map(option => (
                <Edition
                  $isActive={edition === option.value}
                  key={option.value}
                  onClick={() => {
                    updateEdition(option.value);
                    window.location.href = option.href;
                  }}
                >
                  {option.label}
                </Edition>
              ))}
            </NoSsr>
          </EditionList>
          <EpaperLink />
          <SCMPPlusLink />
        </CenterWrapper>
        <RightWrapper>
          {headerFeatureProvider.subscription()}
          {headerFeatureProvider.dashboard()}
        </RightWrapper>
      </Wrapper>
    </Container>
  );
};

HomeEdition.displayName = "HomeEdition";
